import Header from './components/Header';
import Hero from './components/Hero';
import FAQSection from './components/FAQSection';
import MediaSection from './components/MediaSection';
import FeaturesSection from './components/FeaturesSection';
import AboutSection from './components/AboutSection';
import IndexSection from './components/IndexSection';
import AppSection from './components/AppSection';
import RankingSection from './components/RankingSection';
import CardsSection from './components/CardsSection';
import TopicsSection from './components/TopicsSection';
import ContactSection from './components/ContactSection';
import UpdatesSection from './components/UpdatesSection';
import CarouselSection from './components/CarouselSection';
import CommentsSection from './components/CommentsSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <FAQSection />
        <MediaSection />
        <FeaturesSection />
        <AboutSection />
        <IndexSection />
        <AppSection />
        <RankingSection />
        <CardsSection />
        <TopicsSection />
        <ContactSection />
        <UpdatesSection />
        <CarouselSection />
        <CommentsSection />
      </main>
      <Footer />
    </div>
  );
}